$mol_view_tree2_to_js_test_ex_bidi_doubing_right_part_with_same_default_foo $mol_object
	a? <=> b? false
	c? <=> b? false
